import { useEffect, useRef, useState } from 'react';
import { motionLevel } from '../../lib/living';

/* Animates a number from its previous value to `value` (ease-out). */
export default function CountUp({ value = 0, duration = 900, format = (n) => Math.round(n) }) {
    const [shown, setShown] = useState(value);
    const from = useRef(0);

    useEffect(() => {
        if (motionLevel() === 'off') { setShown(value); from.current = value; return undefined; }
        const start = performance.now();
        const a = from.current;
        let raf;
        const step = (now) => {
            const k = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - k, 3);
            setShown(a + (value - a) * eased);
            if (k < 1) raf = requestAnimationFrame(step);
            else from.current = value;
        };
        raf = requestAnimationFrame(step);
        return () => { cancelAnimationFrame(raf); from.current = value; };
    }, [value, duration]);

    return <>{format(shown)}</>;
}
